/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { Button } from 'react-bootstrap';
import Flex from '../Flex';

export const AdvanceTablePagination = ({
  canPreviousPage,
  canNextPage,
  previousPage,
  nextPage,
  pageCount,
  pageIndex,
  gotoPage,
  setCheckChanges
}) => {
  const pages = [...Array(pageCount).keys()];
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Flex alignItems="center" justifyContent="center">
      {pageCount > 1 && (
        <Button
          size="sm"
          variant="falcon-default"
          onClick={() => {
            previousPage();
            scrollToTop();
            setCheckChanges(true);
          }}
          className={classNames({ disabled: !canPreviousPage })}
        >
          <FontAwesomeIcon icon="chevron-left" />
        </Button>
      )}
      <ul className="pagination mb-0 mx-1">
        {pages.map((page, index) => {
          if (
            index === 0 ||
            index === pageCount - 1 ||
            (index >= pageIndex - 2 && index <= pageIndex + 2)
          ) {
            return (
              <li
                key={index}
                className={classNames({ active: pageIndex === index })}
              >
                <Button
                  size="sm"
                  variant="falcon-default"
                  className={classNames('page', {
                    'me-1': 1 !== pageCount
                  })}
                  onClick={() => {
                    gotoPage(index);
                    scrollToTop();
                    setCheckChanges(true);
                  }}
                >
                  {index + 1}
                </Button>
              </li>
            );
          } else if (index === pageIndex - 3 || index === pageIndex + 3) {
            return (
              <li key={index} className={classNames({ active: false })}>
                <Button
                  size="sm"
                  variant="falcon-default"
                  className={classNames('page', {
                    'me-1': 1 !== pageCount
                  })}
                  onClick={() => {
                    gotoPage(index);
                    scrollToTop();
                    setCheckChanges(true);
                  }}
                >
                  ...
                </Button>
              </li>
            );
          } else {
            return null;
          }
        })}
      </ul>
      {pageCount > 1 && (
        <Button
          size="sm"
          variant="falcon-default"
          onClick={() => {
            nextPage();
            scrollToTop();
            setCheckChanges(true);
          }}
          className={classNames({ disabled: !canNextPage })}
        >
          <FontAwesomeIcon icon="chevron-right" />
        </Button>
      )}
    </Flex>
  );
};

export default AdvanceTablePagination;
